// extracted by mini-css-extract-plugin
module.exports = {"authYandexBtn":"style__authYandexBtn__i4hvi","authYandexBtnDisabled":"style__authYandexBtnDisabled__vUM7E","authYandexBtnIcon":"style__authYandexBtnIcon__2FP63"};